import React, { useEffect, useState } from 'react';
import './Header.scss';

const Header = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > lastScrollY;

      if (isScrollingDown && currentScrollY > 100) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = menuOpen ? 'auto' : 'hidden';
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <header
      className={`header ${showHeader ? 'header--visible' : 'header--hidden'}`}>
      <div className='container'>
        <div className='header__wrapper'>
          <a
            href='/'
            className='header__logo'>
            <img
              src='./img/logo.png'
              alt=''
            />
          </a>

          <nav className='header__nav'>
            <a href='#team'>Über uns</a>
            <a href='#services'>Unsere Leistungen</a>
            <a href='#reviews'>Kundenbewertungen</a>
            <a href='#contact'>Kontakt</a>
          </nav>

          <a
            href='tel:+4915789643201'
            className='header__phone'>
            +49 1578 9643201
          </a>

          <div
            className={`header__burger ${menuOpen ? 'active' : ''}`}
            onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <div className={`header__mobile ${menuOpen ? 'open' : ''}`}>
        <nav className='header__mobile-nav'>
          <a
            href='#team'
            onClick={handleLinkClick}>
            Über uns
          </a>
          <a
            href='#services'
            onClick={handleLinkClick}>
            Unsere Leistungen
          </a>
          <a
            href='#reviews'
            onClick={handleLinkClick}>
            Kundenbewertungen
          </a>
          <a
            href='#contact'
            onClick={handleLinkClick}>
            Kontakt
          </a>
        </nav>
        <a
          href='tel:+4917670729363'
          className='header__mobile-phone'>
          +49 176 70729363
        </a>
      </div>
    </header>
  );
};

export default Header;
